import {AxiosService} from './axiosService';

export class EquipmentService extends AxiosService {
    async getList(customerId, pageSize, pageIndex, sortBy, orderBy) {
        try {
            const {data} = await this.axios.get('/equipment', { params : {
                customerId,
                pageSize,
                pageIndex,
                sortBy,
                orderBy
            }});
            return data;
        } catch (e) {
            if (e?.response?.status) {
                return {error: e.response.status, message: e.response.statusText};
            } else {
                return null;
            }
        }
    }
    async viewEquipmentPoints(buildingId, equipmentId) {
        try {
            const {data} = await this.axios.get(`/data/viewEquipmentPoints`, {
                params: {
                    buildingId,
                    equipmentId
                }
            });
            return data;
        } catch (e) {
            // if the status code is a 401 we do NOT want to throw
            if ((e)?.response?.status !== 401) {
                throw e;
            }
        }
        return null;
    }

    async getEquipmentById(equipmentId) {
        try {
            const {data} = await this.axios.get(`/equipment/${equipmentId}`);
            return data;
        } catch (e) {
            if (e?.response?.status) {
                return {error: e.response.status, message: e.response.statusText};
            } else {
                return null;
            }
        }
    }

    async getScheduleTree(componentId){
        try {
            const {data} = await this.axios.get(`/ScheduleTree`, { params : {
                componentId
            }});
            return data;
        } catch (e) {
            if (e?.response?.status) {
                return {error: e.response.status, message: e.response.statusText};
            } else {
                return null;
            }
        }
    }

    async createEquipment(equipment) {
        try {
            const {data} = await this.axios.post('/equipment', equipment);
            return data;
        } catch (e) {
            if (e?.response?.status) {
                return {error: e.response.status, message: e.response.statusText};
            } else {
                return null;
            }
        }
    }

    async getBuildingList(customerId, pageSize, pageIndex, sortBy, orderBy) {
        try {
            const {data} = await this.axios.get('/buildings', { params : {
                    customerId,
                    pageSize,
                    pageIndex,
                    sortBy,
                    orderBy
                }});
            return data;
        } catch (e) {
            if (e?.response?.status) {
                return {error: e.response.status, message: e.response.statusText};
            } else {
                return null;
            }
        }
    }

    async getSpaceList(customerId, pageSize, pageIndex, sortBy, orderBy) {
        try {
            const {data} = await this.axios.get('/spaces', { params : {
                    customerId,
                    pageSize,
                    pageIndex,
                    sortBy,
                    orderBy
                }});
            return data;
        } catch (e) {
            if (e?.response?.status) {
                return {error: e.response.status, message: e.response.statusText};
            } else {
                return null;
            }
        }
    }

    async getMappedEquipmentPoints(groupId) {
        try {
            const {data} = await this.axios.get('/equipment/mappedEquipmentPoints', { params : {
                    groupId
                }});
            return data;
        } catch (e) {
            if (e?.response?.status) {
                return {error: e.response.status, message: e.response.statusText};
            } else {
                return null;
            }
        }
    }

    async updateEquipment(equipment) {
        try {
            const {data} = await this.axios.put('/equipment', equipment);
            return data;
        } catch (e) {
            if (e?.response?.status) {
                return {error: e.response.status, message: e.response.statusText};
            } else {
                return null;
            }
        }
    }

    async deleteEquipment(equipmentId) {
        try {
            const {data} = await this.axios.delete(`/equipment/${equipmentId}`);
            return data;
        } catch (e) {
            if (e?.response?.status) {
                return {error: e.response.status, message: e.response.statusText};
            } else {
                return null;
            }
        }
    }
}

export const equipmentService = new EquipmentService();
